<div>{{ 'components.performance.line_dashboard.line_selection.line' | translate }}</div>
<div class="row">
  <div class="col">
      <s2a-dropdown [data]="lines" [selectedItemId]="selectedLineId" [isLoading]="isLoading" (selectionChanged)="lineSelectionChanged($event)"></s2a-dropdown>
  </div>
</div>

